import { UserRoleName } from 'models'

export const notAllowedUserRolesBySection = {
  projects: [
    UserRoleName.VIEW_PRODUCT_OWNER,
    UserRoleName.PERSON_EDIT_ONLY
  ],
  people: [
    UserRoleName.VIEW_PRODUCT_OWNER,
    UserRoleName.VIEW_CONTENT_OWNER
  ],
  brands: [
    UserRoleName.PERSON_EDIT_ONLY,
    UserRoleName.VIEW_CONTENT_OWNER
  ],
  products: [
    UserRoleName.PERSON_EDIT_ONLY
  ],
  agreements: [
    UserRoleName.OPERATOR_USER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.VIEWER_OPERATOR_USER,
    UserRoleName.PERSON_EDIT_ONLY
  ],
  statistics: [
    UserRoleName.OPERATOR_USER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.VIEWER_OPERATOR_USER,
    UserRoleName.PERSON_EDIT_ONLY
  ],
  actionHistory: [
    UserRoleName.PERSON_EDIT_ONLY
  ],
  viewers: [
    UserRoleName.OPERATOR_USER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.VIEWER_OPERATOR_USER,
    UserRoleName.PERSON_EDIT_ONLY
  ],
  userManagement: [
    UserRoleName.VIEW_PRODUCT_OWNER,
    UserRoleName.OPERATOR_USER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.VIEWER_OPERATOR_USER,
    UserRoleName.PERSON_EDIT_ONLY
  ],
  allowedEmail: [
    UserRoleName.VIEW_PRODUCT_OWNER,
    UserRoleName.OPERATOR_USER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.VIEWER_OPERATOR_USER,
    UserRoleName.PERSON_EDIT_ONLY
  ]
}
